"use strict";

Object.defineProperty(exports, "__esModule", {
   value: true
});
exports.init = init;
exports.getHttps = getHttps;
var _https;

function init(https) {
   _https = https;
}

function getHttps() {
   if (_https) {
      return _https;
   }
   return {};
}


// WEBPACK FOOTER //
// ../~/@jg/koala-front-end-analytics/lib/lib/httpsShim.js